import { useState, useEffect } from "react";
import api from "../../../services/api";
import { VAZIO } from "../constants";

export function useServicos(){
  const [ordens,setOrdens]     = useState([]);
  const [clientes,setClientes] = useState([]);
  const [tecnicos,setTecnicos] = useState([]);
  const [produtos,setProdutos] = useState([]);
  const [pedidos,setPedidos]   = useState([]);
  const [loading,setLoading]   = useState(true);
  const [busca,setBusca]       = useState("");
  const [filtroStatus,setFiltroStatus] = useState("");
  const [abaVis,setAbaVis]     = useState("lista");
  const [modalForm,setModalForm] = useState(null);
  const [form,setForm]         = useState(VAZIO);
  const [itens,setItens]       = useState([]);
  const [salvando,setSalvando] = useState(false);

  const carregar=()=>{
    setLoading(true);
    Promise.all([
      api.get("/servicos/ordens/?page_size=1000"),
      api.get("/clientes/contatos/?page_size=1000"),
      api.get("/funcionarios/funcionarios/?page_size=1000"),
      api.get("/produtos/produtos/?page_size=1000"),
      api.get("/vendas/pedidos/?page_size=1000"),
    ]).then(([oR,cR,fR,prR,pedR])=>{
      setOrdens(oR.data.results||oR.data);
      setClientes((cR.data.results||cR.data).filter(c=>["CONSUMIDOR","ARQ_ENG"].includes(c.categoria)));
      setTecnicos(fR.data.results||fR.data);
      setProdutos((prR.data.results||prR.data).filter(p=>p.grupo==="PRODUTO_FINAL"));
      setPedidos(pedR.data.results||pedR.data);
    }).finally(()=>setLoading(false));
  };
  useEffect(()=>{carregar();},[]);

  const buscarCoordenadas=async(end,cid,est)=>{
    if(!end) return;
    try{const r=await fetch("https://nominatim.openstreetmap.org/search?q="+encodeURIComponent(end+", "+cid+", "+est+", Brasil")+"&format=json&limit=1");const d=await r.json();if(d[0])setForm(f=>({...f,latitude:d[0].lat,longitude:d[0].lon}));}catch{}
  };

  const setF=(f,v)=>{
    let precisaGeocodificar = null;
    setForm(prev=>{
      const n={...prev,[f]:v};
      if(["valor_mo","valor_materiais"].includes(f)){
        n.valor_total=(parseFloat(f==="valor_mo"?v:n.valor_mo||0)+parseFloat(f==="valor_materiais"?v:n.valor_materiais||0)).toFixed(2);
      }
      if(f==="cliente"){
        const c = clientes.find(x=>String(x.id)===String(v));
        n.tipo_cliente = c?.categoria==="ARQ_ENG" ? "ARQ_ENG" : "CONSUMIDOR";
        n.pedido = "";
      }
      if(f==="pedido" && v){
        const cliente = clientes.find(x=>String(x.id)===String(n.cliente));
        const end = (cliente?.enderecos||[]).find(e=>e.principal) || (cliente?.enderecos||[])[0];
        if(end){
          n.endereco = [end.logradouro, end.numero].filter(Boolean).join(", ") + (end.bairro ? " - "+end.bairro : "");
          n.cep = end.cep || "";
          n.cidade = end.cidade || "";
          n.estado = end.estado || "";
          if(end.latitude && end.longitude){
            n.latitude = end.latitude;
            n.longitude = end.longitude;
          } else {
            precisaGeocodificar = { endereco: n.endereco, cidade: n.cidade, estado: n.estado };
          }
        }
      }
      return n;
    });
    if(precisaGeocodificar) buscarCoordenadas(precisaGeocodificar.endereco, precisaGeocodificar.cidade, precisaGeocodificar.estado);
  };

  const setItem=(idx,field,val)=>setItens(prev=>{
    const n=[...prev]; n[idx]={...n[idx],[field]:val};
    if(["quantidade","valor_unit"].includes(field)){
      const q=parseFloat(field==="quantidade"?val:n[idx].quantidade||0);
      const p=parseFloat(field==="valor_unit"?val:n[idx].valor_unit||0);
      n[idx].valor_total=(q*p).toFixed(2);
    }
    const mat=n.reduce((s,i)=>s+parseFloat(i.valor_total||0),0);
    setForm(f=>({...f,valor_materiais:mat.toFixed(2),valor_total:(parseFloat(f.valor_mo||0)+mat).toFixed(2)}));
    return n;
  });

  const selectProduto=(idx,prodId)=>{
    const p=produtos.find(x=>x.id===parseInt(prodId));
    if(!p) return;
    setItens(prev=>{
      const n=[...prev]; n[idx]={...n[idx],produto:prodId,valor_unit:parseFloat(p.preco_custo).toFixed(4),valor_total:parseFloat(p.preco_custo).toFixed(2)};
      const mat=n.reduce((s,i)=>s+parseFloat(i.valor_total||0),0);
      setForm(f=>({...f,valor_materiais:mat.toFixed(2),valor_total:(parseFloat(f.valor_mo||0)+mat).toFixed(2)}));
      return n;
    });
  };

  const addItem=()=>setItens(p=>[...p,{produto:"",quantidade:"1",valor_unit:"0",valor_total:"0"}]);
  const removeItem=idx=>{
    const n=itens.filter((_,i)=>i!==idx);
    setItens(n);
    const mat=n.reduce((s,i)=>s+parseFloat(i.valor_total||0),0);
    setForm(f=>({...f,valor_materiais:mat.toFixed(2),valor_total:(parseFloat(f.valor_mo||0)+mat).toFixed(2)}));
  };

  const salvar=async()=>{
    if(!form.cliente){alert("Selecione o cliente.");return;}
    setSalvando(true);
    try{
      const dados={...form,cliente:parseInt(form.cliente),tecnico:form.tecnico?parseInt(form.tecnico):null,pedido:form.pedido?parseInt(form.pedido):null,data_agendada:form.data_agendada||null};
      let os;
      if(modalForm==="novo"){const r=await api.post("/servicos/ordens/",dados);os=r.data;}
      else{const r=await api.put("/servicos/ordens/"+form.id+"/",dados);os=r.data;const old=await api.get("/servicos/itens/?os="+os.id);for(const it of(old.data.results||old.data))await api.delete("/servicos/itens/"+it.id+"/");}
      for(const it of itens.filter(i=>i.produto)) await api.post("/servicos/itens/",{...it,os:os.id});
      carregar();setModalForm(null);
    }catch{alert("Erro ao salvar.");}
    finally{setSalvando(false);}
  };

  const abrirNovo=()=>{setForm(VAZIO);setItens([]);setModalForm("novo");};
  const abrirEditar=async o=>{
    setForm({...o,cliente:String(o.cliente),tecnico:o.tecnico?String(o.tecnico):"",pedido:o.pedido?String(o.pedido):""});
    const r=await api.get("/servicos/itens/?os="+o.id);
    setItens((r.data.results||r.data).map(i=>({...i,produto:String(i.produto)})));
    setModalForm("editar");
  };
  const excluir=async id=>{if(!window.confirm("Excluir OS?"))return;await api.delete("/servicos/ordens/"+id+"/");carregar();};
  const mudarStatus=async(id,st)=>{await api.patch("/servicos/ordens/"+id+"/",{status:st});setOrdens(prev=>prev.map(o=>o.id===id?{...o,status:st}:o));};

  const filtradas=ordens.filter(o=>(!filtroStatus||o.status===filtroStatus)&&((o.cliente_nome||"").toLowerCase().includes(busca.toLowerCase())||String(o.id).includes(busca)));

  return {
    ordens, clientes, tecnicos, produtos, pedidos, loading,
    busca, setBusca, filtroStatus, setFiltroStatus, abaVis, setAbaVis,
    modalForm, setModalForm, form, itens, salvando,
    setF, setItem, selectProduto, addItem, removeItem,
    buscarCoordenadas, salvar, abrirNovo, abrirEditar, excluir, mudarStatus,
    filtradas,
  };
}
